import { ExternalController } from '@Config/ExternalController';
import React from 'react';

export const ExternalControllerContext = React.createContext(ExternalController);
